import { createSelector } from 'reselect';
import getIn from 'transmute/getIn';
import { getEntry } from 'conversations-async-data/indexed-async-data/operators/getters';
export const getForms = getIn(['threadViewRootReducer', 'forms']);
const getFormIdFromProps = (_, {
  formId
}) => formId;
export const getAsyncFormById = createSelector([getForms, getFormIdFromProps], (forms, formId) => getEntry(formId, forms));